module.exports = __webpack_public_path__ + "4fc2f4d1e744533d83e2b0922309ee21.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/reseller/reseller-company-detail/reseller-company-detail.html
// module id = 1722
// module chunks = 0